module.exports = __webpack_public_path__ + "static/media/PC_Workshop_IBM_WATSON_E_CHATBOTS_INTELIGENTES_COM_COGNIFICACAO.9243d176.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/banners/courses/ibm/PC_Workshop_IBM_WATSON_E_CHATBOTS_INTELIGENTES_COM_COGNIFICACAO.png
// module id = 81
// module chunks = 0